/** @format */

import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WINDOW } from './window/window.service';

@Injectable({
	providedIn: 'root'
})
export class FeatureConfigurationService {
	constructor(
		@Inject(PLATFORM_ID) protected platformId: any,
		@Inject(WINDOW) private window: Window
	) {}

	/**
	 * @description
	 * Event listener for provided Events enum value. Executes the callback provided
	 * when the Event is emitted
	 */
	onFeature(key: string, callback: (params) => void): void {
		if (isPlatformBrowser(this.platformId)) {
			if (typeof this.window['dcsgPz']?.features?.getConfig === 'function') {
				const featureConf = this.window['dcsgPz'].features.getConfig(
					key,
					// eslint-disable-next-line @typescript-eslint/no-shadow
					(featureConf) => {
						if (featureConf?.enabled) {
							callback(featureConf.params);
						}
					}
				);
				if (featureConf?.enabled && featureConf?.initialized) {
					callback(featureConf.params);
				}
			}
		}
	}
}
